import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const CabinetButton = () => {
  const { profile, baseUrl } = useStore();

  const isFastRegUser = profile.user.passed_only_fast_registration;

  return (
    <a
      className={cx("profile-button", "cabinet-button")}
      href={
        isFastRegUser
          ? `https://id.${baseUrl}/contact-edit/?utm_source=header&utm_campaign=new_header`
          : `https://${baseUrl}/office/?utm_source=header&utm_campaign=new_header`
      }
      onClick={() =>
        sendNavigationMetric(
          isFastRegUser ? "PROFILE_CABINET_CONTACT_EDIT" : "PROFILE_CABINET_OFFICE"
        )
      }
    >
      {strings.profile_room}
    </a>
  );
};

export default observer(CabinetButton);
